export const formatAmpersand = (label: string) => {
  return label.includes('&amp;') ? label.replace(/&amp;/g, '&') : label;
};
